/** Shared storage identities without importing operation validation or engines. */
export const PREFERENCES_KEY = 'not-y.preferences.v1';
export const PRESETS_KEY = 'not-y.image-presets.v1';
export const OPERATION_PRESETS_KEY = 'not-y.operation-presets.v1';
